/**
 * Ajax统一后端接口请求入口
 * Created by Administrator on 2018/6/25.
 */

import axios from 'axios'
import Common from '@/js/common.js'
import jQuery from 'jquery'

var service = {};
service.requestCount = 0;
window.FRONT_HOST = process.env.FRONT_HOST;
window.SERVER_BASE = process.env.SERVER_API;
window.SERVER_BASE_ERP = process.env.SERVER_API_ERP;

service.serverUrl = window.SERVER_BASE;
axios.defaults.timeout =30000;                //响应时间
axios.defaults.baseURL = window.SERVER_BASE;   //配置接口地址
axios.defaults.withCredentials = true;
axios.defaults.responseType = 'json';
axios.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

/**
 * 不使用加载器的请求地址
 * @type {string[]}
 */
service.NO_LOADING_URLS = [];
/**
 * 遮罩层的展现或者隐藏
 * @param isShow
 */
service.preloaderDisplay = function (config, isShow) {
  let reqUrl = config.url;
  if (config.url.startsWith(config.baseURL)) {
    reqUrl = config.url.substr(config.baseURL.length - 1);
  }
  for (let noLoadingUrl of service.NO_LOADING_URLS) {
    if(reqUrl.startsWith(noLoadingUrl)){
      return;
    }
  }

  if (isShow) {
    service.requestCount++;
    Common.Preloader.show();
  } else {
    service.requestCount--;
    if(service.requestCount <= 0) {
      service.requestCount = 0;
      Common.Preloader.hidden();
    }
  }
};

/**
 * 全局请求拦截器，计算当前请求数量，并展现遮罩层
 */
axios.interceptors.request.use(function (config) {
  // service.preloaderDisplay(config, true);
  return config;
}, function (error) {
  // service.preloaderDisplay(error.config, false);
  return Promise.reject(error);
});

/**
 * 全局响应拦截器，计算当前请求数量，请求量为0后隐藏遮罩层
 */
axios.interceptors.response.use(function (response) {
  // service.preloaderDisplay(response.config, false);
  return response;
}, function (error) {
  // service.preloaderDisplay(error.config, false);
  return Promise.reject(error);
});


/**
 * 处理响应失败时的提示消息
 * @param response
 * @returns {string}
 */
service.getFailedResponseMsg = function(response)
{
  var errorMsg = "";
  if (response) {
    if (Common.Utils.isString(response) && response.indexOf(" - Error report<\/title>") > 0) {
      var getContent = function (startStr, endStr) {
        var posStart = response.indexOf(startStr);
        if (posStart > 0) {
          var posEnd = response.indexOf(endStr, posStart);
          if (posEnd > 0) {
            var content = response.substring(posStart + startStr.length, posEnd);
            return content;
          }
        }
        return "";
      };
      errorMsg = "错误标题：" + getContent("<body><h1>", "</h1>") + "\r\n"
        + "错误类型：" + getContent("<p><b>type</b>", "</p>").replace("<u>", "") + "\r\n"
        + "错误消息：" + getContent("<b>message</b>", "</u>").replace("<u>", "") + "\r\n"
        + "错误描述：" + getContent("<b>description</b>", "</u>").replace("<u>", "") + "\r\n";
    }
    if (Common.Utils.isObject(response) && Common.Utils.isString(response.message)) {
      errorMsg = response.message;
    }
  } else {
    errorMsg = "无法连接服务器";
  }
  if (errorMsg.startsWith("Network Error")) {
    errorMsg = "暂时无法连接服务器，请联系客服人员！";
  } else if (errorMsg.startsWith("timeout of ")) {
    errorMsg = "操作请求超时，请重试！";
  }
  return errorMsg;
};

/**
 * 成功获取下载数据后展现下载窗口
 * @param response
 */
service.showDownloadWindow = function(response)
{
  var fileName =response.headers['content-disposition'];
  fileName = fileName.substring(fileName.indexOf("filename=") + 10, fileName.length-1);
  fileName = decodeURI(fileName);
  var contentType = response.headers['content-type'];
  contentType = contentType.split(";")[0];
  if(fileName.substring(fileName.length-4) == "xlsx")
  {
    contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  }
  else if(fileName.substring(fileName.length-3) == "xls")
  {
    contentType = "application/vnd.ms-excel";
  }
  var file=new Blob([response.data], {type: contentType});
  //判断是不是Ie游览器
  if (!!window.ActiveXObject || "ActiveXObject" in window)
  {
    window.navigator.msSaveBlob(file,fileName);
  }
  else
  {
    var url = URL.createObjectURL(file);
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName;
    a.target = '_blank';
    a.click();
    a.remove();
  }
};

/**
 * 初始化请求头部类型及参数
 * @param config
 * @param contentType
 * @param urlData
 * @returns {*}
 */
service.initConfig = function (config, contentType, urlData) {
  if(!config)
  {
    config = {};
  }
  if (contentType) {
    config['headers'] = {};
    config['headers']['Content-Type'] = contentType + ';charset=utf-8';
  }
  if(urlData)
  {
    config.params = urlData;
  }
  return config;
};


/**  Before Send the request filter **/
service.beforeRequest = function (vm, url, urlData) {
  url = Common.Request.beforeSend(vm, url, urlData);
  return url;
};

/**  After Send the request filter **/
service.afterRequest = function (vm, url, postData, promise) {
  var deferred = jQuery.Deferred();
  promise.then(function (response) {
    deferred.resolve(response.data);
    return
    var handleResult = Common.Request.afterResponse(vm, response.data, url, postData);
    if (handleResult != "abort") {
      deferred.resolve(handleResult);
    } else {
      deferred.reject("系统已处理");
    }
  }, function (response) {
    var errorMsg = service.getFailedResponseMsg(response);
    // Common.PageOperator.showPromptMsg(vm, true, errorMsg, 'error');
    deferred.reject(errorMsg);
  });
  return deferred.promise();
};


/**
 *
 * @param vm
 * @param url
 * @param postData
 * @param urlData
 * @param config
 */
service.post = function (vm, url, postData, urlData, config) {
  service.serverUrl = window.SERVER_BASE;
  axios.defaults.baseURL = window.SERVER_BASE;   //配置接口地址
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.post(url, postData, config);
  return service.afterRequest(vm, url, postData, promise);
};

service.erpPost = function (vm, url, postData, urlData, config) {
  service.serverUrl = window.SERVER_BASE_ERP;
  axios.defaults.baseURL = window.SERVER_BASE_ERP;   //配置接口地址
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.post(url, postData, config);
  return service.afterRequest(vm, url, postData, promise);
};

/**
 *
 * @param vm
 * @param url
 * @param urlData
 */
service.get = function (vm, url, urlData) {
  service.serverUrl = window.SERVER_BASE;
  axios.defaults.baseURL = window.SERVER_BASE;   //配置接口地址
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.get(url);
  return service.afterRequest(vm, url, null, promise);
};

service.erpGet = function (vm, url, urlData) {
  service.serverUrl = window.SERVER_BASE_ERP;
  axios.defaults.baseURL = window.SERVER_BASE_ERP;   //配置接口地址
  url = service.beforeRequest(vm, url, urlData);
  var promise = axios.get(url);
  return service.afterRequest(vm, url, null, promise);
};

var errorCodeMsg = {
  "0": "无法连接服务器，服务已停止",
  "400": "错误的请求",
  "401" : "访问被拒绝",
  "403" : "禁止访问",
  "404" : "服务未找到或服务已停止",
  "405" : "用来访问本页面的 HTTP 谓词不被允许（方法不被允许）",
  "406" : "客户端浏览器不接受所请求页面的 MIME 类型",
  "407" : "要求进行代理身份验证",
  "412" : "前提条件失败",
  "413" : "请求实体太大",
  "414" : "请求 URI 太长",
  "415" : "不支持的媒体类型",
  "416" : "所请求的范围无法满足",
  "417" : "执行失败",
  "423" : "锁定的错误"
};

export default service;



// WEBPACK FOOTER //
// ./src/js/service.js